export default {
  "site.name": "黄油游戏官方指南",
  "site.tagline": "玩法攻略与资源大全",
  "nav.home": "首页",
  "nav.categories": "攻略分类",
  "nav.about": "关于我们",
  "nav.guides": "玩法攻略",
  "hero.title": "黄油游戏官方指南",
  "hero.subtitle": "最全面的黄油游戏玩法攻略与资源大全",
  "hero.description": "汇集完整玩法教程、角色攻略、隐藏资源与新手入门技巧，帮助每位玩家快速上手、深度体验，解锁全部精彩内容",
  "hero.cta": "开始探索",
  "hero.secondary": "新手教程",
  "section.featured": "精选攻略",
  "section.featured.desc": "最受欢迎的游戏攻略与技巧分享",
  "section.categories": "攻略分类",
  "section.categories.desc": "按分类浏览您感兴趣的内容",
  "section.faq": "常见问题",
  "section.faq.desc": "新手常见问题快速解答",
  "section.latest": "最新攻略",
  "section.latest.desc": "持续更新的游戏攻略内容",
  "article.readMore": "阅读全文",
  "article.publishedAt": "发布时间",
  "article.category": "分类",
  "article.related": "相关攻略",
  "article.backToList": "返回列表",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "category.all": "全部",
  "category.title": "攻略分类",
  "category.description": "浏览不同分类的游戏攻略，找到您需要的教程与技巧",
  "about.title": "关于我们",
  "about.subtitle": "黄油游戏官方指南",
  "about.intro": "品牌介绍",
  "about.intro.content": "黄油游戏官方指南是国内领先的黄油游戏攻略资源平台，致力于为每一位黄油游戏玩家提供最全面、最专业的游戏攻略、玩法教程和资源大全。自成立以来，我们始终坚持以玩家需求为核心，汇聚了大量资深玩家的实战经验和独家技巧。",
  "about.reputation": "玩家口碑",
  "about.reputation.content": "我们已帮助超过百万玩家解决了游戏中的各种难题，从新手入门到高手进阶，从基础操作到隐藏内容解锁，每一篇攻略都经过精心编撰和实战验证，赢得了广大玩家的信赖与好评。",
  "about.contact": "联系我们",
  "about.contact.desc": "如有任何问题或建议，欢迎通过以下方式联系我们",
  "about.email": "电子邮箱",
  "about.wechat": "微信公众号",
  "about.qq": "QQ群",
  "contact.form.title": "在线留言",
  "contact.form.name": "您的称呼",
  "contact.form.email": "电子邮箱",
  "contact.form.message": "留言内容",
  "contact.form.submit": "提交留言",
  "contact.form.success": "留言提交成功，我们会尽快回复您！",
  "contact.form.error": "提交失败，请稍后重试",
  "footer.copyright": "黄油游戏官方指南. 致力于为玩家提供最优质的游戏攻略服务。",
  "footer.links": "快速链接",
  "footer.resources": "资源导航",
  "footer.contact": "联系方式",
  "scrollToTop": "回到顶部",
}